const UTM_SESSION_KEY = 'pt_utm_attr'

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'yclid'] as const

export type UtmAttribution = Partial<Record<(typeof UTM_PARAMS)[number], string>> & {
  page_path?: string
}

/** Вызывается при первой загрузке страницы. Если в URL есть UTM — сохраняет в sessionStorage. */
export function captureUtmFromUrl(url: URL): void {
  let hasUtm = false
  const data: UtmAttribution = {}

  for (const param of UTM_PARAMS) {
    const value = url.searchParams.get(param)
    if (value) {
      data[param] = sanitizeUtmValue(value)
      hasUtm = true
    }
  }

  if (!hasUtm) return

  data.page_path = url.pathname

  try {
    sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify(data))
  } catch {
    // sessionStorage может быть недоступен (приватный режим)
  }
}

/** Читает сохранённую UTM-атрибуцию из sessionStorage. */
export function readUtmAttribution(): UtmAttribution | null {
  try {
    const raw = sessionStorage.getItem(UTM_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as UtmAttribution
  } catch {
    return null
  }
}

/** Очищает HTML-теги и ограничивает длину — защита от XSS через query params. */
function sanitizeUtmValue(value: string): string {
  return value.replace(/<[^>]*>/g, '').slice(0, 200)
}
